<template>
    <div class="graph-card">
        <div class="graph-header">
            <div class="table-heading">
                <d-tooltip placement="left" identifier="employees.timeWithCustomers" />
                {{ heading }}
                <slot></slot>
            </div>
            <!--<div>
                Graftype:
            </div>
            <select v-model="type">
                <option value="bar">Bar</option>
                <option value="line">Linje</option>
                <option value="area">Areal</option>
            </select>-->
        </div>

        <vue-apex-charts :height="height" :options="options" :series="getSeries" v-if="!loading" class="graph-data-box" />
        
        <box-loading height="465" v-else />

        <!--<div class="box-date-range" v-if="!loading">
            <div class="text">
                <i class="fal fa-calendar" />
            </div>
            <datepicker :language="datepickerLocale" class="date-picker" v-model="startDate" placeholder="Startdato"></datepicker>
            <div class="to">
                <i class="fal fa-chevron-right" />
            </div>
            <datepicker :language="datepickerLocale" class="date-picker" v-model="endDate" placeholder="Slutdato"></datepicker>
        </div>-->
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'
    import VueApexCharts from 'vue-apexcharts'
    import * as calculationService from '@/services/calculationService'
    import moment from 'moment'
    import { da } from 'vuejs-datepicker/dist/locale'

    export default {
        components: {
            Datepicker,
            VueApexCharts
        },
        props: {
            heading: String,
            unit: String,
            ylabel: String,
            height: String,
            trend: Boolean,
            endpoint: String,
            paramsInEndpoint: Boolean,
            dynamicInterval: Boolean,
            series: Array
        },
        data () {
            return {
                datepickerLocale: da,
                loading: true,
                startDate: this.$store.state.config.startDate,
                endDate: this.$store.state.config.endDate,
                values: [...this.series],
                options: {
                    colors: ['#172b43', '#F44336', '#9C27B0', '#3F51B5', '#4CAF50', '#FF9800'],
                    labels: [],
                    plotOptions: {
                        bar: {
                            columnWidth: '50%'
                        }
                    },
                    stroke: {
                        width: [...(() => {
                            return this.series.map(series => {
                                return series.width
                            })
                        })(), 3], // Laver array med width fra hvert object i series (defaulter til 0)
                        curve: 'smooth'
                    },
                    dataLabels: {
                        enabled: false
                    },
                    yaxis: {
                        labels: {
                            formatter: value => {
                                return Math.round(value) + ' ' + this.unit
                            }
                        },
                        title: {
                        text: this.ylabel
                        },
                        min: 0,
                        max: 100
                    },
                    tooltip: {
                        shared: true,
                        intersect: false,
                        followCursor: true,
                        y: {
                            formatter: y => {
                                if (typeof y !== 'undefined') {
                                return y.toFixed(0) + ' ' + this.unit
                                }
                                return y
                            }
                        }
                    },
                    chart: {
                        toolbar: {
                            show: false
                        }
                    }
                }
            }
        },
        computed: {
            companyId () {
                return this.$store.state.companyId || this.$auth.user().company_id
            },
            dataUrl () {
                return this.endpoint + (this.paramsInEndpoint ? '&' : '?') + 'date_from=' + this.formatDate(this.startDate) + '&date_to=' + this.formatDate(this.endDate)
            },
            storeStartDate () {
                return this.$store.state.config.startDate
            },
            storeEndDate () {
                return this.$store.state.config.endDate
            },
            getSeries () {
                if (this.trend) {
                    return [...this.values, this.average]
                } else {
                    return [...this.values]
                }
            },
            average () {
                let averages = []
                if (this.values[0].data) {
                    let sum = 0
                    let n = 1
                    this.values[0].data.forEach(value => {
                        sum += value
                        averages.push(sum / n)
                        n++
                    })
                }
                return {
                    name: 'Trend',
                    type: 'line',
                    data: averages
                }
            }
        },
        methods: {
            /* setType (type) {
                this.type = type
            }, */
            getData () {
                this.loading = true
                calculationService.find(this.dataUrl, {}, response => {
                    // Set labels
                    this.options = {
                        ...this.options,
                        ...{
                            labels: response.data.labels
                    }}
                    // Set data-series
                    Object.keys(response.data.values).forEach((seriesKey, index) => {
                        this.values = [{
                            ...this.values[index],
                            data: response.data.values[seriesKey]
                        }]
                        const maxValue = Math.max(...this.values[index].data)
                        if (this.dynamicInterval && maxValue > this.options.yaxis.max) {
                            this.options.yaxis.max = maxValue * 1.2
                        }
                    })
                    this.loading = false
                }, (err) => {
                    this.loading = false
                    return err
                })
            },
            formatDate (date) {
                return moment(date).format('YYYY-MM-DD')
            }
        },
        created () {
            this.getData()
        },
        watch: {
            storeStartDate: function (date) {
                this.startDate = date
            },
            storeEndDate: function (date) {
                this.endDate = date
            },
            dataUrl: function () {
                this.getData()
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .graph-data-box {
        height: 450px !important;
        animation: fadeIn 0.3s ease-in-out forwards;
    }
    
    .graph-header {
        /* display: flex;
        justify-content: space-between; */

        .table-heading {
            font-size: $fontsize--sm;
            padding: $padding--small;
            font-weight: $fontweight--bold;
            color: $color--white;
            background: $color--dark;
            text-align: center;
        }
    }
</style>

<style lang="scss">
@import "../../styles/vars.scss";

    .apexcharts-legend.center.position-bottom {
        bottom: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// GraphCard.vue?2f289be2